import { render, staticRenderFns } from "./QuotizationsDashboard.vue?vue&type=template&id=6b95d676&lang=pug&"
import script from "./QuotizationsDashboard.vue?vue&type=script&lang=js&"
export * from "./QuotizationsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports